// src/modules/app-views/_apps/appmulti/coupons/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Row, Col } from 'antd';
import { useDocumentContext } from 'components/core/DocumentProvider';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import SimpleSelectAsyncEntities from 'components/SimpleComponents/SimpleSelectAsyncEntities';
import translateX from 'utils/translateX';
import couponsModuleService from 'modules/app-views/_apps/appmulti/coupons/service';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const STYLES = {
  container: { position: 'relative', minHeight: 120 },
  cardMargin: { marginBottom: 16 },
};

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const RecordTab = () => {
  // ---------------------------------------------------------------------------
  // PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { data } = useDocumentContext();
  const { locked } = useSimpleFormContext();

  // ---------------------------------------------------------------------------
  // HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  const discountTypeOptions = couponsModuleService.getDiscountTypes();

  // ---------------------------------------------------------------------------
  // LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <div className="container" style={STYLES.container}>
      <Card title={translateX('coupon')} style={STYLES.cardMargin}>
        <Row gutter={16}>
          <Col xs={24} sm={12} lg={6}>
            <SimpleInput name="name" label="code" required disabled={locked} />
          </Col>
          <Col xs={24} sm={12} lg={5}>
            <SimpleNumber
              name="discount"
              label="discount"
              required
              min={0.01}
              max={999999.99}
              decimalPlaces={2}
              disabled={locked}
            />
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <SimpleSelect
              name="type"
              label="discount_type"
              required
              options={discountTypeOptions}
              disabled={locked}
            />
          </Col>
          <Col xs={24} sm={12} lg={4}>
            <SimpleNumber
              name="qty"
              label="quantity"
              required
              min={1}
              max={999999}
              disabled={locked}
            />
          </Col>
          <Col xs={24} sm={12} lg={5}>
            <SimpleSelectAsyncEntities
              name="operatorId"
              label="operator"
              entityProfiles={['operator']}
              selectedEntity={data?.__operator}
              disabled={locked}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={12} lg={6}>
            <SimpleDatePicker name="startDate" label="start_date" disabled={locked} />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <SimpleDatePicker
              name="expirationDate"
              label="expiration_date"
              required
              disabled={locked}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24}>
            <SimpleTextArea name="description" label="description" rows={2} disabled={locked} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default RecordTab;
